import { RegistrationNumberSearchReviewComponent } from "projects/reg-hub-client/src/app/orders/registration-number-search-review/registration-number-search-review.component";
import { RegistrationNumberSearchCriteriaComponent } from "projects/reg-hub-client/src/app/orders/registration-number-search-criteria/registration-number-search-criteria.component";
import { SearchStepper, eCriteriaVariation } from "../search-stepper";
import { StepValidationState } from "projects/reg-hub-client/src/interfaces/step";

export class NTRegistrationNumberSearchStepper extends SearchStepper {

    constructor() {
        super()
        this.configuration = [
        ];

        this.steps = [
            { title: "Search Criteria", content: RegistrationNumberSearchCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: RegistrationNumberSearchReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}